import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import {
  ActionsEnum,
  fetchLabelsError,
  FetchLabelsError,
  fetchLabelsSuccess,
  FetchLabelsSuccess,
  SendEmail,
  sendEmailError,
  SendEmailError,
  sendEmailSuccess,
  SendEmailSuccess,
} from './refer-a-friend-data.actions';
import { ReferAFriendLabels } from './refer-a-friend-labels.model';
import { ReferAFriendDataService } from './refer-a-friend-data.service';
import { showToast, ShowToast } from '../toaster/toaster.actions';
import { MessageToastComponent } from '../shared/components/message-toast/message-toast.component';
import { IToasterConfig, IToasterData } from '../toaster/toaster.data';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class ReferAFriendDataEffects {
  constructor(
    private _actions: Actions,
    private _referAFriendDataService: ReferAFriendDataService,
    private _translateService: TranslateService
  ) {}

  @Effect()
  fetchLabels: Observable<
    FetchLabelsSuccess | FetchLabelsError
  > = this._actions.pipe(
    ofType(ActionsEnum.FETCH_LABELS),
    switchMap(() => {
      return this._referAFriendDataService.fetchLabels().pipe(
        map((referAFriendLabels: ReferAFriendLabels) =>
          fetchLabelsSuccess(referAFriendLabels)
        ),
        catchError((error) => of(fetchLabelsError(error)))
      );
    })
  );

  @Effect()
  sendEmail: Observable<SendEmailSuccess | SendEmailError> = this._actions.pipe(
    ofType(ActionsEnum.SEND_EMAIL),
    switchMap(({ payload }: SendEmail) => {
      const { email } = payload;

      return this._referAFriendDataService.sendEmail(email).pipe(
        map(() => sendEmailSuccess(email)),
        catchError((error) => of(sendEmailError(error)))
      );
    })
  );

  @Effect()
  sendEmailSuccess: Observable<ShowToast> = this._actions.pipe(
    ofType(ActionsEnum.SEND_EMAIL_SUCCESS),
    map(({ payload }: SendEmailSuccess) => {
      const { email } = payload;
      const toastData: IToasterData = {
        label: this._translateService.instant('REFER_A_FRIEND.SUCCESS_EMAIL', {
          email,
        }),
        containsHtml: true,
      };
      const toastConfig: IToasterConfig = {
        type: 'message-copied-clipboard',
        component: MessageToastComponent,
        data: toastData,
      };

      return showToast(toastConfig);
    })
  );
}
